// extracted by mini-css-extract-plugin
export var imageSelectedField = "InputImage_imageSelectedField__FIs3l";
export var imgPreview = "InputImage_imgPreview__ZttEi";
export var colImgInfo = "InputImage_colImgInfo__qD5F1";
export var textInfo = "InputImage_textInfo__IcGyr";
export var textSize = "InputImage_textSize__vdMxq";
export var btnDelete = "InputImage_btnDelete__quLFQ";
export var rotate = "InputImage_rotate__nIynT";
export var dotty = "InputImage_dotty__duQ3d";